import React, { useEffect, useState, Fragment } from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import { FaHeart, FaFlag  } from 'react-icons/fa';
import { FiArrowLeft  } from 'react-icons/fi';
import { useUser } from "../../store/UserContext";
import {checkToken} from '../../Authentication/AxiosInstance';

const ForumQueryRepliesPage = () => {
    const {user} = useUser();
    console.log(user);
    const navigate = useNavigate();
    const { id } = useParams(); // Get query ID from URL
    const [responseData, setResponseData] = useState(null);
    const [query, setQuery] = useState(null);
    const [error, setError] = useState(null);
    const [replies, setReplies] = useState([]);
    const [isReplyActive, setIsReplyActive] = useState(false);
    const [isReplyAdded, setIsReplyAdded] = useState(false);
    const [replyText, setReplyText] = useState('');
    const [showSessionExpired, setShowSessionExpired] = useState(false);
    // const [datePart, setDatePart] = useState('');
    // const [timePart, setTimePart] = useState('');
    
    const buttonClass = `m-2 p-2 h-auto w-fit 
                  bg-transparent text-primary-900 hover:text-white hover:bg-primary-900 
                  border-2 rounded-lg 
                  text-base font-bold tracking-widest normal-case items-center`;
    
    const dateFormatFn = (v_date) => {
        console.log(v_date)
        if (!v_date) return null; // Prevent undefined errors
        const dateObj = new Date(v_date)
        let fullDate = null;
        let datePart = null;
        let timePart = null;
        if (v_date.length <= 10) {
            fullDate = dateObj.toLocaleDateString("en-GB", { month: "short", day: "2-digit", year: "2-digit" });
            datePart = fullDate.split(',')[0]
            timePart = null
        } else {
            fullDate = dateObj.toLocaleDateString("en-GB",{ month: "short", day: "2-digit", year: "2-digit"} ) + ", " + dateObj.toLocaleTimeString("en-GB", { hour:'numeric', minute:'numeric', hour12: true }).toUpperCase();
            datePart = fullDate.split(',')[0]
            timePart = fullDate.split(',')[1].trim()
        }
        console.log(fullDate, datePart,timePart)
        return [datePart,  timePart];
    };

    const handleCancel = () => {
        setIsReplyActive(false);
        setReplyText('');
        setIsReplyAdded(false);
      };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Submitting:', replyText);
        console.log('Query id', query)
        console.log('user', user)
        console.log(id)
        try {
            await checkToken.post(`api/queries/reply/${id}/`, {
                                  "c002_response_text": replyText || null,
            },
            );
            setReplyText('');
            setIsReplyActive(false);
            setIsReplyAdded(true);
            console.log('saved')
        } catch (err) {
            setIsReplyAdded(false);
            console.error('Failed to save your response:', err);
            if (err.response) {
              // Server responded with a status code outside the 2xx range
                setError(err.message)
            } else if (err.request) {
                  // Request was made but no response
                  setError("No response from server");
            } else {
                  // Something else happened setting up the request
                  setError("Your post could not be recorded: " + err);
            }
        }
        
    }
    
    const QueryLikeButton = ({query}) => {
        const v_liked = query?.c002_isliked_by_user || false; // Check first for reply, then for query.
        const [liked, setLiked] = useState(v_liked);
        let liked_count = query?.c002_like_count || 0
        const handleLike = async () => {
          console.log('clicked')
          try {
            await checkToken.post('/api/forumlike/', {
                                  c002_query: query?.id,
                                  c002_reply: null
            },
           );
            setLiked(!liked);
            try {
              const res = await checkToken.get(`/api/queries/${query?.id}/`);
              console.log(res.data)
              setResponseData(res.data);
              setError('');
            } catch (err) {
                console.log(err)
                setError("Error fetching query:", err.response ? err.response.data : err.message);
                if (!user) {
                  setShowSessionExpired(true);
                }
            }
          } catch (err) {
            console.log(err)
            setError('Failed to update like flag:', err.response?.statusText);
          }
        };
          
        console.log(liked_count)
        console.log(liked)
        return (
          <div className="flex flex-row space-x-1 text-left items-center">
              <button
                className={`text-sm h-4 w-4 ${liked ? 'text-red-500' : 'text-gray-500'}`}
                onClick={handleLike}
                disabled={!user}
              > <FaHeart/>
               </button>
              <span className="text-base">{liked_count}</span>
            </div>
          );
          
    };
    const ReplyLikeButton = ({ query, reply }) => {
      const v_liked = reply?.c002_isliked_by_user|| false// Check first for reply, then for query.
      const [liked, setLiked] = useState(v_liked);
      let liked_count = reply?.c002_response_like_count || 0
      const handleLike = async () => {
        try {
          await checkToken.post('/api/forumlike/', {
                                c002_query: query?.id,
                                c002_reply: reply?.id 
          },
         );
          setLiked(!liked);
          try {
            const res = await checkToken.get(`/api/queries/${query?.id}/`);
            console.log(res.data)
            setResponseData(res.data);
            setError('');
          } catch (err) {
              console.log(err)
              setError("Error fetching query:", err.response ? err.response.data : err.message);
              if (!user) {
                setShowSessionExpired(true);
              }
          }
        } catch (err) {
          setError('Failed to update like flag:', err.response.statusText);
        }
      };
        
      console.log(liked_count)
      console.log(liked)
      return (
        <div className="flex flex-row space-x-1 text-left items-center">
            <button
              className={`text-sm h-4 w-4 ${liked ? 'text-red-500' : 'text-gray-500'}`}
              onClick={handleLike}
              disabled={!user}
            > <FaHeart/>
             </button>
            <span className="text-base">{liked_count ? liked_count : '0'}</span>
          </div>
        );
        
    };
      
    const ReplyFlagButton = ({ query, reply }) => {
      console.log('Flag clicked')
      console.log(query)
      console.log(reply)
                
      const handleFlagSubmit = async (e) => {
        e.stopPropagation(); // prevent box's onClick from firing
        try {
          const queryId = query?.id;
          const replyId = reply?.id;
          await checkToken.post("/api/forumflag/", {
            c002_query: queryId,
            c002_reply: replyId
          });
          try {
              const res = await checkToken.get(`/api/queries/${id}/`);
              console.log(res.data.c002_replies)
              setResponseData(res.data)
              setError('');
          } catch (err) {
              console.log(err)
              setError("Error fetching query:", err.response ? err.response.data : err.message);
              if (!user) {
              setShowSessionExpired(true);
              }
          }
        } catch (err) {
          console.log(err);
          setError("Flag submission failed:", err);
        } 

      };
      console.log(user)
      return (
        <div className="flex">
          <button className={`group flex items-center space-x-2 ${buttonClass} cursor-pointer p-0 m-0`}
                  disabled={!user} 
                  onClick={handleFlagSubmit} >
            <FaFlag className="text-gray-500 group-hover:text-red-500 p-0 m-0 align-middle" />
            <span className="text-primary-900 font-bold group-hover:text-white p-0 m-0 leading-none">
                  Report as InAppropriate
            </span>
          </button>
        </div>
      );
    };

    useEffect(() => {
        const fetchQuery = async () => {
            try {
                console.log(id)
                const res = await checkToken.get(`/api/queries/${id}/`);
                console.log(res.data)
                setResponseData(res.data);
                setError('');
            } catch (err) {
                console.log(err)
                setError("Error fetching query:", err.response ? err.response.data : err.message);
                if (!user) {
                  setShowSessionExpired(true);
                }
            }
        };
        console.log(id);
        fetchQuery();
    }, [id, isReplyAdded, user]);
    
    // Whenever fresh data is fetched from database
    useEffect(() => {
      if (responseData) {
        console.log(responseData)
        setQuery({ ...responseData, c002_replies: undefined }); // if you want to remove replies
        setReplies(responseData.c002_replies || []); // Keep only replies
      }
    },[responseData]);
    const [queryDate, queryTime] = query? dateFormatFn(query.c002_query_created_date):[null,null]
    console.log(replies)
    return (
      <Fragment>
        <>
          {showSessionExpired && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white p-0 rounded shadow text-center">
                  <div className="border-2 border-primary-500">
                    <p className="bg-primary-500 text-white font-bold text-lg font-sans ml-0 mr-0 p-2">College Avenue</p>
                    <p className="pt-8 pl-4 pr-4">Your session has expired. Please log in again.</p>
                    <button onClick={() => setShowSessionExpired(false)} className={`${buttonClass}`}>
                      Close
                    </button>
                  </div>
                </div>
              </div>
          ) }
        </>
        <>
          {console.log(query)}
          {query && Object.keys(query).length > 0  && (
            <div>
              <div className="bg-gradient-to-r from-primary-100 to-primary-200 border border-primary-300 rounded-xl p-6 shadow-md m-6">
                {/* Back Page */}
                  <div className="flex flex-row items-start">
                    <div  onClick={() => navigate('/community')} // or your custom back logic
                          className="ml-6 w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center cursor-pointer hover:bg-primary-700 transition">
                          <FiArrowLeft className="text-white text-xl" />
                    </div>
                    {/* Query Section */}
                    <div className="text-gray-700 border-b border-tertiary-500 ml-6 mb-4 text-xs">
                        <p>{query.c002_query_authorname} </p>
                          <p>{queryDate} {queryTime}</p>
                    </div>
                  </div>
                  <h1 className="text-xl font-semibold ml-6">{query.c002_query_subject}</h1>
                  <div className="text-base ml-6 mt-2 mr-2 mb-2 ">{query.c002_query_description}</div>
                  <div className="flex flex-row text-base ml-6 mt-4 mr-2 text-center items-center justify-between gap-x-2">
                      <QueryLikeButton query = {query} reply={null}/>
                  </div>
              </div>
              {/* Replies Section */}
              <div className="ml-6 mb-8 mr-6 border-b border-tertiary-500">
                  <h2 className="text-lg font-medium border-b border-tertiary-500 mt-8 mb-4">Replies</h2>
                  {/* Reply Form */}
                  { user && 
                        <form onSubmit={handleSubmit}>
                            <textarea
                            rows={isReplyActive ? 4 : 1}
                            value={replyText}
                            onChange={(e) => setReplyText(e.target.value)}
                            onFocus={()=> setIsReplyActive(true)}
                            placeholder='Join the conversation'
                            className="w-full p-3 border border-tertiary-500 rounded-lg resize-none text-sm focus:outline-none focus:ring-offset-0 focus:ring-primary-500"
                            required
                            />
                            {isReplyActive && (
                                <div className="relative bottom-2 right-3 flex gap-2">
                                    <button  type="cancel"  className={`${buttonClass}`} onClick={handleCancel}>Cancel</button>
                                    <button  type="submit"  className={`${buttonClass}`} >Reply</button>
                                </div>
                            )}
                        </form>
                  }
                  {replies.length === 0 ? (
                      <p className="text-sm text-gray-500">No replies yet.</p>
                      ) : (
                      replies.map((reply, index) => {
                          const [responseDate, responseTime] = dateFormatFn(reply.c002_response_created_date);
                          return (
                            <div key={index} className="flex flex-row items-stretch justify-center gap-x-4">
                                <div  
                                    className="flex items-center bg-gradient-to-r from-primary-100 to-primary-200 border border-primary-300 
                                                w-1/6 mb-4 white shadow-sm p-4 rounded-xl hover:shadow-lg transition 
                                                gap-x-6">
                                    <div className="flex flex-col items-center align-middle space-x-1 text-[12px]">
                                            <div className="font-medium align-middle text-[12px]">{reply.c002_response_authorname}</div>
                                            <div className="text-xs">{responseDate}&nbsp;{responseTime}</div>
                                    </div>
                                </div>
                                {reply.c002_isreplyflagged ? (
                                  <div className="w-5/6 mb-1 bg-white shadow-sm p-4 rounded-xl hover:shadow-lg transition 
                                                  border gap-x-6">
                                      <div className="flex flex-row items-stretch italic bg-transparent">
                                          <div className="flex flex-col flex-1 justify-between">
                                              <h3 className="font-semibold text-gray-400 mb-1">This content is under moderation</h3>
                                              <div className="text-gray-800 text-base mt-2 mb-1 mr-6">This content was manually reported as violating our code of conduct and hence, has been placed under moderation. </div>
                                          </div>
                                      </div>
                                  </div>
                                ) : (
                                  <div className="w-5/6 mb-4 bg-white shadow-sm p-4 rounded-xl hover:shadow-lg transition border gap-x-6">
                                      <div className="text-gray-800 text-base mt-2 mb-2 mr-6">{reply.c002_response_text}</div>
                                      <div className="flex flex-row text-base mt-4 mr-6 text-center items-center justify-end gap-x-2">
                                          <div><ReplyLikeButton query = {query} reply = {reply} /></div>
                                          {user && (
                                          <div className="flex"><ReplyFlagButton query = {query} reply = {reply}/> </div>
                                          )}
                                      </div>
                                  </div>
                                )}
                            </div>
                      )}) 
                  )}
              </div>
            </div>
          )}
        </>
      </Fragment>
    )
};
export default ForumQueryRepliesPage;
